module.exports = __webpack_public_path__ + "06_long_gold.f785f96d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/06_long_gold.png
// module id = /w58
// module chunks = 0